// extracted by mini-css-extract-plugin
var _1 = "TitleDuoTone_primaryColor__Lbr7Q";
var _2 = "TitleDuoTone_title__c+U1x";
var _3 = "TitleDuoTone_wrapper__rZlt6";
export { _1 as "primaryColor", _2 as "title", _3 as "wrapper" }
